var _circle, _path, _g, _path2, _path3, _path4, _g2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIllPhoneNotification(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 88 90",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 43.6835,
    cy: 46.1608,
    r: 33.5903,
    fill: "#F1F3F9"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_4883_6281)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4883_6281",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 16,
    y: 5,
    width: 55,
    height: 82
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.2129 5.11247L65.137 8.48008C68.648 8.95446 70.9886 12.3479 70.1847 15.7984L54.8165 81.7622C54.0363 85.1109 50.6105 87.1233 47.3057 86.1742L21.3422 78.718C18.1985 77.8152 16.3542 74.5639 17.1926 71.4024L33.6001 9.52714C34.3765 6.59913 37.211 4.70686 40.2129 5.11247Z",
    fill: "#231C45"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4883_6281)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.2129 5.11247L65.137 8.48008C68.648 8.95446 70.9886 12.3479 70.1847 15.7984L54.8165 81.7622C54.0363 85.1109 50.6105 87.1233 47.3057 86.1742L21.3422 78.718C18.1985 77.8152 16.3542 74.5639 17.1926 71.4024L33.6001 9.52714C34.3765 6.59913 37.211 4.70686 40.2129 5.11247Z",
    fill: "#231C45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.1366 5.26934L65.4946 8.96385C67.9527 9.32199 69.5831 11.7003 69.0307 14.1222L53.831 80.7653C53.0697 84.1032 49.6776 86.1314 46.3769 85.2224L21.4972 78.37C18.3225 77.4956 16.4429 74.229 17.2823 71.0449L33.4599 9.68363C34.2391 6.72837 37.1123 4.82872 40.1366 5.26934Z",
    fill: "#231C45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.4585 9.21161L40.1005 5.5171C37.2022 5.09483 34.4487 6.91533 33.702 9.74746L17.5244 71.1087C16.7199 74.1602 18.5212 77.2907 21.5637 78.1286L46.4434 84.981C49.6065 85.8522 52.8573 83.9084 53.5869 80.7096L68.7866 14.0665C69.3065 11.7871 67.772 9.54868 65.4585 9.21161Z",
    stroke: "#2DB2B2",
    strokeOpacity: 0.5,
    strokeWidth: 0.500746
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.9145 6.50127L64.4605 10.1958C66.4777 10.5123 67.7985 12.4791 67.3281 14.4661L51.8283 79.9365C51.3083 82.1331 49.0769 83.4665 46.896 82.8838L21.7034 76.1521C19.5688 75.5818 18.299 73.3908 18.8654 71.2551L35.0173 10.3478C35.7077 7.74447 38.2537 6.08378 40.9145 6.50127Z",
    fill: "url(#paint0_linear_4883_6281)"
  })))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.538 10.4687C36.9405 8.99738 38.3829 8.06231 39.8903 8.29545L63.9442 12.0158C65.0815 12.1917 65.8361 13.2887 65.5936 14.4136L63.882 22.3557C63.5433 23.9276 62.0254 24.9529 60.4407 24.6803L36.0709 20.4879C34.9072 20.2877 34.1693 19.1282 34.4809 17.9892L36.538 10.4687Z",
    fill: "#3A3262"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.0247 16.0232C61.8956 16.5254 61.4041 16.8456 60.8926 16.7608L49.2834 14.8367C48.7046 14.7407 48.3324 14.1694 48.4784 13.6012L48.5576 13.2932C48.6866 12.791 49.1781 12.4708 49.6896 12.5556L61.2988 14.4797C61.8776 14.5757 62.2499 15.147 62.1038 15.7152L62.0247 16.0232Z",
    fill: "white",
    fillOpacity: 0.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.6896 19.2727C54.5592 19.7801 54.0593 20.1009 53.5437 20.0079L48.2518 19.0537C47.6799 18.9506 47.3161 18.3835 47.4607 17.8207L47.5404 17.5105C47.6709 17.0031 48.1708 16.6823 48.6864 16.7753L53.9783 17.7294C54.5501 17.8326 54.914 18.3997 54.7694 18.9625L54.6896 19.2727Z",
    fill: "white",
    fillOpacity: 0.5
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4883_6281)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.3339 11.068L39.1472 12.1683C39.0045 12.2051 38.885 12.3248 38.8524 12.4881C38.8198 12.6513 38.8837 12.8186 39.0045 12.913L41.6674 14.8997L43.4364 14.5291C43.4364 14.5291 42.1841 11.4171 42.1823 11.4162C42.1683 11.3701 42.157 11.3137 42.1685 11.2611C42.188 11.1682 42.2576 11.0968 42.3358 11.0689L42.3339 11.068Z",
    fill: "#2DB2B2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.4366 14.5291L41.6676 14.8997L44.3306 16.8864C44.3773 16.9248 44.4131 16.9673 44.4398 17.0147L43.4375 14.5318L43.4366 14.5291Z",
    fill: "#7280FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.1826 11.4163L43.4385 14.5301L44.8791 14.2289C45.0273 14.1948 45.1513 14.0748 45.1858 13.9078C45.2176 13.7558 45.1656 13.6058 45.0639 13.5088L42.5677 11.1184C42.5384 11.0906 42.5009 11.0705 42.459 11.0599C42.3277 11.0301 42.198 11.1195 42.1698 11.2593C42.1583 11.3166 42.1595 11.3659 42.1835 11.4144L42.1826 11.4163Z",
    fill: "#00D5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.1536 18.3815L39.8977 15.2677L38.4571 15.5688C38.3089 15.603 38.1849 15.7229 38.1504 15.89C38.1186 16.042 38.1706 16.192 38.2723 16.2889L40.7666 18.6785C40.796 18.7063 40.8334 18.7264 40.8763 18.7351C41.0076 18.7649 41.1373 18.6755 41.1655 18.5357C41.177 18.4784 41.1758 18.4291 41.1518 18.3806L41.1536 18.3815Z",
    fill: "#FFC000"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.0021 18.7296L44.1897 17.6274C44.3324 17.5906 44.4519 17.4709 44.4845 17.3076C44.5171 17.1444 44.4532 16.9771 44.3324 16.8827L41.6695 14.896L39.9006 15.2666L41.1546 18.3795C41.1686 18.4256 41.1799 18.482 41.1684 18.5346C41.1489 18.6275 41.0811 18.6998 41.0011 18.7268L41.0021 18.7296Z",
    fill: "#FF3F8F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.8998 15.2685L41.6687 14.8979L39.0048 12.9131C38.9581 12.8748 38.9233 12.835 38.8975 12.7856L39.8998 15.2685Z",
    fill: "#7280FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_4883_6281",
    x: 11.9828,
    y: 0.0504042,
    width: 61.365,
    height: 89.3635,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1.00149,
    dy: -1.00149
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.00298
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.266667 0 0 0 0 0.337255 0 0 0 0 0.866667 0 0 0 0.18 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4883_6281"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4883_6281",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4883_6281",
    x1: 61.4151,
    y1: 15.563,
    x2: 9.65965,
    y2: 92.6284,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E7F0FF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4883_6281"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 7.17781,
    height: 7.62143,
    fill: "white",
    transform: "translate(40.0581 9.91699) rotate(25.3662)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllPhoneNotification);
export default __webpack_public_path__ + "static/media/ill-phone-notification.0a178228dc970346b9f9f00e893dead4.svg";
export { ForwardRef as ReactComponent };